import { render, staticRenderFns } from "./MedicalLeaveDetail.vue?vue&type=template&id=73690efb"
import script from "./MedicalLeaveDetail.vue?vue&type=script&lang=js"
export * from "./MedicalLeaveDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports